import React, { PropsWithChildren } from 'react';

import { isAudio } from './content-utils';
import { MediaHeroAudioPlayer } from './MediaHeroAudioPlayer';
import { MediaHeroVideoPlayer } from './MediaHeroVideoPlayer';
import { Content } from './types';

export const MediaHeroPlayer: React.FC<
  PropsWithChildren<{
    content: Content;
  }>
> = ({ content, children }) => {
  if (isAudio(content)) {
    return <MediaHeroAudioPlayer content={content}>{children}</MediaHeroAudioPlayer>;
  }
  return <MediaHeroVideoPlayer content={content}>{children}</MediaHeroVideoPlayer>;
};
